/* PROFILE */

export const UPDATE_PROFILE = "UPDATE_PROFILE"
export const UPDATE_PROFILE_SUCCESS = "UPDATE_PROFILE_SUCCESS"
export const UPDATE_PROFILE_FAIL = "UPDATE_PROFILE_FAIL"

export const UPDATE_PROFILE_VERIFICATION = "UPDATE_PROFILE_VERIFICATION"
export const UPDATE_PROFILE_VERIFICATION_SUCCESS = "UPDATE_PROFILE_VERIFICATION_SUCCESS"
export const UPDATE_PROFILE_VERIFICATION_FAIL = "UPDATE_PROFILE_VERIFICATION_FAIL"
export const RESET_PROFILE_VERIFICATION = "RESET_PROFILE_VERIFICATION"

export const GET_PROFILE_DATA_BY_TAB = "GET_PROFILE_DATA_BY_TAB";
export const GET_PROFILE_DATA_BY_TAB_SUCCESS = "GET_PROFILE_DATA_BY_TAB_SUCCESS";
export const GET_PROFILE_DATA_BY_TAB_FAIL = "GET_PROFILE_DATA_BY_TAB_FAIL";

export const CREATE_SALESMAN = "CREATE_SALESMAN";
export const CREATE_SALESMAN_SUCCESS = "CREATE_SALESMAN_SUCCESS";
export const CREATE_SALESMAN_FAIL = "CREATE_SALESMAN_FAIL";

export const DELETE_SALESMAN = "DELETE_SALESMAN";
export const DELETE_SALESMAN_SUCCESS = "DELETE_SALESMAN_SUCCESS";
export const DELETE_SALESMAN_FAIL = "DELETE_SALESMAN_FAIL";

export const SET_SALESMAN_AS_DEFAULT = "SET_SALESMAN_AS_DEFAULT";
export const SET_SALESMAN_AS_DEFAULT_SUCCESS = "SET_SALESMAN_AS_DEFAULT_SUCCESS";
export const SET_SALESMAN_AS_DEFAULT_FAIL = "SET_SALESMAN_AS_DEFAULT_FAIL";

export const REMOVE_TEAM_MEMBER = "REMOVE_TEAM_MEMBER";
export const REMOVE_TEAM_MEMBER_SUCCESS = "REMOVE_TEAM_MEMBER_SUCCESS";
export const REMOVE_TEAM_MEMBER_FAIL = "REMOVE_TEAM_MEMBER_FAIL";

export const INVITE_TEAM_MEMBER = "INVITE_TEAM_MEMBER";
export const INVITE_TEAM_MEMBER_SUCCESS = "INVITE_TEAM_MEMBER_SUCCESS";
export const INVITE_TEAM_MEMBER_FAIL = "INVITE_TEAM_MEMBER_FAIL";

export const REINVITE_TEAM_MEMBER = "REINVITE_TEAM_MEMBER";
export const REINVITE_TEAM_MEMBER_SUCCESS = "REINVITE_TEAM_MEMBER_SUCCESS";
export const REINVITE_TEAM_MEMBER_FAIL = "REINVITE_TEAM_MEMBER_FAIL";

export const REMOVE_TEAM_MEMBER_INVITATION = "REMOVE_TEAM_MEMBER_INVITATION";
export const REMOVE_TEAM_MEMBER_INVITATION_SUCCESS = "REMOVE_TEAM_MEMBER_INVITATION_SUCCESS";
export const REMOVE_TEAM_MEMBER_INVITATION_FAIL = "REMOVE_TEAM_MEMBER_INVITATION_FAIL";

export const RESET_PROFILE_STATE = "RESET_PROFILE_STATE";
export const RESET_PROFILE_ACTION_STATE = "RESET_PROFILE_ACTION_STATE";
